import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { Utils } from '../../Utils/Utils';

export interface DetailPageOptions extends PageOptionsBase {
}

export class DetailPage extends PageBase<DetailPageOptions> {
    public init() {
        // this will redraw table as 'datatable'
        DatatableApi.attach('userRoleUsers');
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Roles/DetailPage.ts
 **/